<template>
  <div class="lab">
    <div class="lab-inner">
      <div class="head">
        <span class="head-title">实验室搜索结果</span>
        <span>共{{ markerList.length || 0 }}个项目</span>
      </div>
      <div class="lab-map">
        <baidu-map
          class="mapArea"
          :center="center"
          :zoom="zoom"
          @ready="mapReady"
        >
          <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
          <bm-marker
            :position="item"
            @click="item.show = true"
            v-for="(item, index) in markerList"
            :key="index"
          >
            <bm-info-window
              :position="item"
              :show="item.show"
              @close="item.show = false"
              @open="item.show = true"
            >
              <div class="win">
                <div class="win-title">{{ item.laboratoryName }}</div>
                <div class="flex">
                  <div v-if="item.laboratoryLogo" class="win-imgWrap">
                    <img class="win-img" :src="item.laboratoryLogo" />
                  </div>
                  <div class="win-info">
                    <div class="flex flex-middle">
                      <i class="el-icon-document"></i>
                      <el-link type="primary" @click="winClick(item)"
                        >实验室详情</el-link
                      >
                    </div>
                    <div class="flex flex-middle">
                      <i class="el-icon-star-off"></i>
                      <el-link type="primary" @click="showList(item)"
                        >特色设备列表</el-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </bm-info-window>
          </bm-marker>
        </baidu-map>
      </div>
    </div>
  </div>
</template>
<script>
import { nearByLabs } from "@/api/lab";
export default {
  props: {},
  data() {
    return {
      zoom: 10,
      markerList: [],
      center: { lng: 114.264307, lat: 30.589903 },
    };
  },
  methods: {
    winClick(data) {
      this.$jump.push({
        name: "labDetail",
        query: { id: data.laboratoryId },
      });
    },
    showList(data) {
      this.$emit("showList", data);
    },
    async mapReady() {
      const res = await this.$axios.get(nearByLabs);
      const { mapCenterLatitude, mapCenterLongitude, mapRespondList } = res;
      Object.assign(this.center, {
        lng: mapCenterLongitude,
        lat: mapCenterLatitude,
      });
      const result = mapRespondList.map((i) => {
        const { laboratoryLongitude, laboratoryLatitude, ...rest } = i;
        return {
          lng: laboratoryLongitude,
          lat: laboratoryLatitude,
          show: false,
          ...rest,
        };
      });
      this.markerList = result;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.lab {
  display: block;
  background: #ebeef4;
  padding-bottom: 20px;
  padding-top: 33px;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    min-height: 400px;
    margin-bottom: 20px;
  }
  .head {
    background: #dbe3f2;
    padding: 10px 15px;
    margin-bottom: 30px;

    &-title {
      font-size: 16px;
      font-weight: bold;
      margin-right: 10px;
    }
  }
  .mapArea {
    width: 100%;
    height: 450px;
  }
  .win {
    &-info {
      padding: 0 10px;
      color: var(--primary);
      line-height: 24px;
      i {
        margin-right: 5px;
      }
    }
    &-title {
      font-weight: bold;
      margin-bottom: 5px;
      padding-top: 5px;
    }
    &-imgWrap {
      width: 150px;
      height: 70px;
      background: #ededed;
    }
    &-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
